import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext, LanguageToggle } from './LanguageToggle';
import GarminCompatibaleLogo from './img/garmin_logo.png';
import StravaCompatibaleLogo from './img/api_logo_cptblWith_strava_stack_light.svg';
import StripeLogo from './img/stripe-ar21.svg';
import InstagramLogo from './img/instagram.svg';

const Footer = () => {
  const { language } = useContext(LanguageContext);

  return (
    <footer className="bg-white/80 backdrop-blur-sm border-t bottom-1 w-full mt-8 lg:mt-12">
      <div className="container mx-auto px-4 py-0 lg:py-4">
        <div className="flex flex-col space-y-4 lg:space-y-6">
          <div className="flex items-center justify-center">
            <p className="text-gray-600 text-sm">
              &copy; {new Date().getFullYear()} Map Prints. {
                language === 'en' ? 'All rights reserved.' : 'Alle Rechte vorbehalten.'
              }
            </p>
          </div>
          <div className="flex flex-wrap justify-center items-center gap-x-4 underline decoration-gray-300 text-sm text-gray-600">
            <Link to="/about" className="hover:decoration-gray-900 hover:text-gray-900">
              {language === 'en' ? 'About' : 'Über uns'}
            </Link>
            <Link to="/contact" className="hover:decoration-gray-900 hover:text-gray-900">
              {language === 'en' ? 'Contact' : 'Kontakt'}
            </Link>
            <Link to="/terms" className="hover:decoration-gray-900 hover:text-gray-900">
              {language === 'en' ? 'Terms of Use' : 'Nutzungsbedingungen'}
            </Link>
            <Link to="/privacy" className="hover:decoration-gray-900 hover:text-gray-900">
              {language === 'en' ? 'Privacy Policy' : 'Datenschutzerklärung'}
            </Link>
            <Link to="/refund" className="hover:decoration-gray-900 hover:text-gray-900">
              {language === 'en' ? 'Refund Policy' : 'Rückgaberecht'}
            </Link>
            <Link to="/impressum" className="hover:decoration-gray-900 hover:text-gray-900">
              Impressum
            </Link>
            <button
              type="button"
              onClick={() => window.dispatchEvent(new CustomEvent('open-cookie-settings'))}
              className="underline decoration-gray-300 hover:decoration-gray-900 hover:text-gray-900 bg-transparent border-0 p-0 text-sm text-gray-600 cursor-pointer"
            >
              {language === 'en' ? 'Cookie Settings' : 'Cookie-Einstellungen'}
            </button>
          </div>
          <LanguageToggle />
          <div className="flex items-center justify-center gap-4 pb-2">
            <img
              src={GarminCompatibaleLogo}
              alt="Compatible with Garmin"
              className="h-6"
            />
            <img
              src={StravaCompatibaleLogo}
              alt="Compatible with Strava"
              className="h-6"
            />
            <img
              src={StripeLogo}
              alt="Powered by Stripe"
              className="h-6"
            />
            <a
              href="https://instagram.com/mapprints_original"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
            >
              <img
                src={InstagramLogo}
                alt="Follow us on Instagram"
                className="h-6 hover:opacity-80 transition"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
